
(function () {
  'use strict';

  var root = document.getElementById('rsd-bf26');
  if (!root) return;

  var source = window.RSD_BF26_DATA || { event: 'rsd-bf2026', items: [] };
  var items = Array.isArray(source.items) ? source.items.slice() : [];
  var byId = Object.create(null);
  items.forEach(function (item) {
    if (!item || !item.id) return;
    item.id = String(item.id);
    item.releaseType = normalizeReleaseType(item.releaseType || 'Other');
    item.pressed = typeof item.pressingCount === 'number' && item.pressingCount >= 100 ? item.pressingCount : null;
    byId[item.id] = item;
  });

  var FEATURED_TITLES = [
    'Ween - Shinola, Vol. 2',
    'NAV / Metro Boomin - Perfect Timing',
    'Masayoshi Takanaka - Super Takanaka Live!',
    'Noah Kahan - The Great Divide: The Last of the Bugs',
    'Vince Guaraldi Trio - A Charlie Brown Christmas (Advent Calendar Edition)',
    'Grateful Dead - Carousel Ballroom, San Francisco, CA, 2/14/68 (Live)',
    'Masayoshi Takanaka - Super Selection',
    "Vince Guaraldi - Charlie Brown's All Stars!",
    'King Gizzard & The Lizard Wizard - Expand Your Mind: Songs In 3D (Deluxe)',
    'Playboi Carti - Music - Sorry 4 Da Wait'
  ];
  var featuredIds = FEATURED_TITLES.map(function (fullTitle) {
    var hit = items.find(function (item) { return (item.fullTitle || '').trim() === fullTitle; });
    return hit ? hit.id : null;
  }).filter(Boolean);
  var featuredRank = Object.create(null);
  featuredIds.forEach(function (id, index) { featuredRank[id] = index + 1; });

  var storageKey = 'vinyl-frontier-rsd-bf26-local-want-list';
  var picks = [];
  try {
    var stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) picks = stored.map(String).filter(function (id) { return !!byId[id]; });
  } catch (e) {}
  picks = Array.from(new Set(picks));

  var state = { search: '', releaseType: '', sort: 'artist' };
  var els = {
    featured: document.getElementById('rsd26-featured-track'),
    grid: document.getElementById('rsd26-grid'),
    count: document.getElementById('rsd26-count'),
    noResults: document.getElementById('rsd26-no-results'),
    search: document.getElementById('rsd26-search'),
    releaseType: document.getElementById('rsd26-release-type'),
    sort: document.getElementById('rsd26-sort'),
    wantButton: document.getElementById('rsd26-want-button'),
    dialog: document.getElementById('rsd26-detail-dialog'),
    dialogContent: document.getElementById('rsd26-detail-content'),
    wantDialog: document.getElementById('rsd26-want-dialog'),
    wantItems: document.getElementById('rsd26-want-items'),
    wantCountLine: document.getElementById('rsd26-want-countline'),
    emailForm: document.getElementById('rsd26-self-email-form'),
    emailInput: document.getElementById('rsd26-self-email'),
    emailButton: document.getElementById('rsd26-email-wants'),
    copyButton: document.getElementById('rsd26-copy-wants'),
    emailMessage: document.getElementById('rsd26-email-message')
  };

  function safe(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function safeImage(url) {
    var value = String(url || '');
    if (!value) return '';
    if (/^https?:\/\//i.test(value) || value.indexOf('//') === 0 || value.indexOf('/') === 0) return safe(value);
    if (/^data:image\/(?:webp|png|jpeg);base64,[a-z0-9+/=]+$/i.test(value)) return value;
    return '';
  }

  function money(value) {
    if (value === null || value === undefined || value === '') return '';
    var n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return '';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);
  }

  function normalizeReleaseType(value) {
    var s = String(value || '').toLowerCase();
    if (s.indexOf('exclusive') !== -1) return 'Exclusive';
    if (s.indexOf('limited') !== -1) return 'Limited Run';
    if (s.indexOf('rsd first') !== -1 || s.indexOf('first') !== -1) return 'RSD First';
    return 'Other';
  }

  function hasPressing(item) {
    return typeof item.pressed === 'number' && Number.isFinite(item.pressed) && item.pressed >= 100;
  }

  function imageFor(item) {
    // Always try the original Shopify CDN image first, including in the offline demo.
    // The embedded small Alliance thumbnail is an offline fallback, never the primary image.
    return safeImage(item.image || item.previewImage || '');
  }

  function artTag(item, lazy) {
    var url = imageFor(item);
    if (!url) return '<span class="rsd26-missing-art">Artwork coming soon</span>';
    var fallback = item.image && item.previewImage ? safeImage(item.previewImage) : '';
    return '<img src="' + url + '" alt="' + safe(cardTitle(item)) + ' cover art"'
      + (fallback ? ' data-rsd-fallback="' + fallback + '"' : '')
      + (lazy ? ' loading="lazy"' : '')
      + ' decoding="async" data-rsd-cover="1">'
      + '<span class="rsd26-missing-art" hidden>Artwork unavailable</span>';
  }

  function msrpMarkup(item, detail) {
    var price = money(item.price);
    var cl = detail ? 'rsd26-detail-price' : 'rsd26-card-price';
    var high = money(Number(item.price) + 5);
    return '<div class="' + cl + '">' + (price ? ('<small>Estimated price</small> ' + safe(price) + '–' + safe(high)) : '<small>Price TBA</small>') + '</div>';
  }

  function cardTitle(item) {
    return item.fullTitle || [item.artist, item.title].filter(Boolean).join(' - ') || 'Untitled release';
  }

  function cardSub(item) {
    return item.vendor || ''; // The format is already shown once as a badge.
  }

  function savePicks() {
    try { localStorage.setItem(storageKey, JSON.stringify(picks)); } catch (e) {}
  }

  function hasPick(id) { return picks.indexOf(String(id)) !== -1; }

  function togglePick(id) {
    id = String(id);
    if (!byId[id]) return;
    if (hasPick(id)) picks = picks.filter(function (x) { return x !== id; });
    else picks.push(id);
    savePicks();
    syncPickButtons();
    renderWantDialog();
  }

  function syncPickButtons() {
    var count = picks.length;
    if (els.wantButton) els.wantButton.textContent = 'My want list (' + count + ')';
    root.querySelectorAll('[data-pick-id]').forEach(function (button) {
      var id = button.getAttribute('data-pick-id');
      var active = hasPick(id);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remove from want list' : 'Add to want list');
      if (button.classList.contains('rsd26-detail-pick')) {
        button.textContent = active ? 'Remove from my want list' : 'Add to my want list';
      } else {
        button.innerHTML = active ? '&#10003;' : '+';
      }
    });
  }

  function releaseTypeCounts() {
    var counts = { 'Exclusive': 0, 'Limited Run': 0, 'RSD First': 0 };
    items.forEach(function (item) {
      if (counts[item.releaseType] != null) counts[item.releaseType] += 1;
    });
    return counts;
  }

  function fillFilters() {
    var counts = releaseTypeCounts();
    [
      ['', 'Every release type'],
      ['Exclusive', 'Exclusive (' + counts.Exclusive + ')'],
      ['Limited Run', 'Limited Run (' + counts['Limited Run'] + ')'],
      ['RSD First', 'RSD First (' + counts['RSD First'] + ')']
    ].forEach(function (pair) {
      var option = document.createElement('option');
      option.value = pair[0];
      option.textContent = pair[1];
      els.releaseType.appendChild(option);
    });
  }

  function compareAlphabetical(a, b) {
    return cardTitle(a).localeCompare(cardTitle(b), undefined, { sensitivity: 'base' });
  }

  function filteredItems() {
    var q = state.search.trim().toLowerCase();
    var rows = items.filter(function (item) {
      if (state.releaseType && item.releaseType !== state.releaseType) return false;
      if (!q) return true;
      return [item.fullTitle, item.artist, item.title, item.vendor, item.barcode, item.releaseType, item.format]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .indexOf(q) !== -1;
    });

    rows.sort(function (a, b) {
      if (state.sort === 'featured') {
        var ra = featuredRank[a.id] || 9999;
        var rb = featuredRank[b.id] || 9999;
        if (ra !== rb) return ra - rb;
        return compareAlphabetical(a, b);
      }
      if (state.sort === 'price_low' || state.sort === 'price_high') {
        var pa = a.price === null ? NaN : Number(a.price);
        var pb = b.price === null ? NaN : Number(b.price);
        if (!Number.isFinite(pa) || pa <= 0) pa = state.sort === 'price_low' ? Infinity : -1;
        if (!Number.isFinite(pb) || pb <= 0) pb = state.sort === 'price_low' ? Infinity : -1;
        if (Number.isFinite(a.price) && !Number.isFinite(b.price)) return -1;
        if (Number.isFinite(b.price) && !Number.isFinite(a.price)) return 1;
        if (pa !== pb) return state.sort === 'price_low' ? pa - pb : pb - pa;
        return compareAlphabetical(a, b);
      }
      if (state.sort === 'rarest' || state.sort === 'most_pressed') {
        // Releases with unknown runs always go after documented quantities.
        if (hasPressing(a) && !hasPressing(b)) return -1;
        if (hasPressing(b) && !hasPressing(a)) return 1;
        var aa = hasPressing(a) ? a.pressed : Infinity;
        var bb = hasPressing(b) ? b.pressed : Infinity;
        if (aa !== bb) return state.sort === 'rarest' ? aa - bb : bb - aa;
        return compareAlphabetical(a, b);
      }
      return compareAlphabetical(a, b);
    });
    return rows;
  }

  function artMarkup(item, extraClass, rank) {
    var rankHtml = rank ? '<span class="rsd26-rank">' + rank + '</span>' : '';
    var imageHtml = artTag(item, true);
    return '<div class="rsd26-cover-wrap">'
      + '<button type="button" class="rsd26-cover ' + (extraClass || '') + '" data-open-id="' + safe(item.id) + '">' + imageHtml + '</button>'
      + rankHtml
      + '<button type="button" class="rsd26-pick" data-pick-id="' + safe(item.id) + '" aria-pressed="false" aria-label="Add to want list">+</button>'
      + '</div>';
  }

  function badgeMarkup(item) {
    var out = ['<div class="rsd26-badges">'];
    out.push('<span class="rsd26-badge">' + safe(item.releaseType || 'Other') + '</span>');
    if (item.format) out.push('<span class="rsd26-badge rsd26-badge--secondary">' + safe(item.format) + '</span>');
    // These are the distributor's Total US Qty Available, not worldwide press totals.
    var pressLabel = hasPressing(item) ? (new Intl.NumberFormat('en-US').format(item.pressed) + ' US copies') : 'US Qty Undisclosed';
    out.push('<span class="rsd26-badge rsd26-badge--pressed">' + safe(pressLabel) + '</span>');
    out.push('</div>');
    return out.join('');
  }

  function itemCard(item, featured) {
    var titleClass = featured ? 'rsd26-card-title rsd26-card-title--small' : 'rsd26-card-title';
    return '<article class="' + (featured ? 'rsd26-featured-card' : 'rsd26-card') + '" data-card-id="' + safe(item.id) + '">'
      + artMarkup(item, '', featured ? featuredRank[item.id] : null)
      + '<div class="rsd26-card-body">'
      + badgeMarkup(item)
      + '<button type="button" class="' + titleClass + '" data-open-id="' + safe(item.id) + '">' + safe(cardTitle(item)) + '</button>'
      + '<p class="rsd26-card-sub">' + safe(cardSub(item)) + '</p>'
      + msrpMarkup(item, false)
      + '<button type="button" class="rsd26-card-link" data-open-id="' + safe(item.id) + '">Details</button>'
      + '</div>'
      + '</article>';
  }

  function renderFeatured() {
    var html = featuredIds.map(function (id) { return byId[id]; }).filter(Boolean).map(function (item) {
      return itemCard(item, true);
    }).join('');
    els.featured.innerHTML = html;
  }

  function renderGrid() {
    var rows = filteredItems();
    // Featured is a curated browse list, not part of filtered search results.
    // Hide it when a filter or search is active so the results are immediately visible.
    var featuredSection = document.getElementById('rsd26-featured');
    if (featuredSection) featuredSection.hidden = Boolean(state.search.trim() || state.releaseType);
    els.count.innerHTML = '<strong>' + rows.length + '</strong> releases currently listed';
    var notice = document.getElementById('rsd26-sort-notice');
    if (notice) notice.hidden = state.sort !== 'rarest' && state.sort !== 'most_pressed';
    if (!rows.length) {
      els.grid.innerHTML = '';
      els.noResults.hidden = false;
      syncPickButtons();
      return;
    }
    els.noResults.hidden = true;
    els.grid.innerHTML = rows.map(function (item) { return itemCard(item, false); }).join('');
    syncPickButtons();
  }

  function openDetail(id) {
    var item = byId[String(id)];
    if (!item) return;
    var imageHtml = artTag(item, false);
    var metaParts = [item.vendor, item.barcode ? ('UPC ' + item.barcode.replace(/^'+/, '')) : ''].filter(Boolean);
    els.dialogContent.innerHTML = ''
      + '<button type="button" class="rsd26-close" data-close="detail" aria-label="Close">&times;</button>'
      + '<div class="rsd26-detail-body">'
      + '  <div class="rsd26-detail-art">' + imageHtml + '</div>'
      + '  <div class="rsd26-detail-copy">'
      +        badgeMarkup(item)
      + '    <h2>' + safe(cardTitle(item)) + '</h2>'
      + '    <p class="rsd26-detail-meta">' + safe(metaParts.join(' • ')) + '</p>'
      +      msrpMarkup(item, true)
      + '    <div class="rsd26-detail-actions">'
      + '      <button type="button" class="rsd26-button rsd26-detail-pick" data-pick-id="' + safe(item.id) + '" aria-pressed="false">Add to my want list</button>'
      + '      <button type="button" class="rsd26-button" data-close="detail">Back to list</button>'
      + '    </div>'
      + '    <p class="rsd26-detail-note">Preview only. Nothing on this page can be purchased. Online sales begin Saturday morning at 8 AM EST while inventory lasts.</p>'
      + '    <div class="rsd26-detail-desc">' + safe(item.description || 'Description coming soon.') + '</div>'
      + '  </div>'
      + '</div>';
    syncPickButtons();
    if (typeof els.dialog.showModal === 'function') els.dialog.showModal();
    else els.dialog.setAttribute('open', 'open');
  }

  function renderWantDialog() {
    if (!els.wantItems) return;
    var list = picks.map(function (id) { return byId[id]; }).filter(Boolean);
    if (els.emailButton) els.emailButton.disabled = !list.length;
    if (els.copyButton) els.copyButton.disabled = !list.length;
    if (els.emailMessage) els.emailMessage.textContent = '';
    if (!list.length) {
      els.wantItems.innerHTML = '<div class="rsd26-empty">You have not added anything to your want list yet.</div>';
      els.wantCountLine.textContent = '0 titles saved locally in this browser.';
      return;
    }
    els.wantItems.innerHTML = list.map(function (item) {
      var imageHtml = artTag(item, false);
      return '<div class="rsd26-want-item">'
        + imageHtml
        + '<div><strong>' + safe(cardTitle(item)) + '</strong><small>' + safe([item.releaseType, item.format].filter(Boolean).join(' • ')) + '</small></div>'
        + '<button type="button" class="rsd26-remove" data-pick-id="' + safe(item.id) + '">Remove</button>'
        + '</div>';
    }).join('');
    els.wantCountLine.textContent = list.length + (list.length === 1 ? ' title saved locally in this browser.' : ' titles saved locally in this browser.');
  }

  function openWantDialog() {
    renderWantDialog();
    if (typeof els.wantDialog.showModal === 'function') els.wantDialog.showModal();
    else els.wantDialog.setAttribute('open', 'open');
  }

  function emailListText() {
    var selected = picks.map(function (id) { return byId[id]; }).filter(Boolean);
    // Plain text only, deliberately without prices, UPCs, artwork or tracking links.
    return selected.map(function (item) {
      var format = item.emailFormat || (item.format === 'Vinyl' ? 'LP' : item.format || 'Release');
      return cardTitle(item) + ' [' + format + ']';
    }).join('\n\n');
  }

  function handleEmailSubmit(event) {
    event.preventDefault();
    if (!picks.length) {
      if (els.emailMessage) els.emailMessage.textContent = 'Add a record to your list first.';
      return;
    }
    var address = els.emailInput ? els.emailInput.value.trim() : '';
    if (!address || !els.emailInput.checkValidity()) {
      if (els.emailInput) els.emailInput.reportValidity();
      return;
    }
    var body = emailListText();
    if (!body) return;
    var uri = 'mailto:' + encodeURIComponent(address)
      + '?subject=' + encodeURIComponent('RSD Black Friday Want List')
      + '&body=' + encodeURIComponent(body);
    if (els.emailMessage) {
      els.emailMessage.textContent = 'Your email app will open with your list addressed to you. Press Send there to email it to yourself.';
    }
    // No Shopify contact form or backend is involved. The visitor sends the email.
    window.location.href = uri;
  }

  function handleCopyWantList() {
    var text = emailListText();
    if (!text) return;
    function feedback(message) {
      if (els.emailMessage) els.emailMessage.textContent = message;
    }
    function fallbackCopy() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        var succeeded = document.execCommand('copy');
        feedback(succeeded ? 'Want list copied. Paste it into any email or note.' : 'Your browser could not copy the list. Select and copy the titles from your want list.');
      } catch (ignore) {
        feedback('Your browser could not copy the list. Select and copy the titles from your want list.');
      }
      document.body.removeChild(textarea);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        feedback('Want list copied. Paste it into any email or note.');
      }).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  }

  function closeDialog(which) {
    var dialog = which === 'want' ? els.wantDialog : els.dialog;
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function onRootClick(event) {
    var pick = event.target.closest('[data-pick-id]');
    if (pick) {
      togglePick(pick.getAttribute('data-pick-id'));
      return;
    }
    var open = event.target.closest('[data-open-id]');
    if (open) {
      openDetail(open.getAttribute('data-open-id'));
      return;
    }
    var close = event.target.closest('[data-close]');
    if (close) {
      closeDialog(close.getAttribute('data-close'));
      return;
    }
    // Clicking the card body also opens the details, not just the cover/title.
    var card = event.target.closest('[data-card-id]');
    if (card) openDetail(card.getAttribute('data-card-id')); 
  }

  fillFilters();
  renderFeatured();
  renderGrid();
  renderWantDialog();
  syncPickButtons();
  root.addEventListener('click', onRootClick);
  root.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || !img.hasAttribute('data-rsd-cover')) return;
    var fallback = img.getAttribute('data-rsd-fallback');
    if (fallback && !img.hasAttribute('data-rsd-did-fallback')) {
      img.setAttribute('data-rsd-did-fallback', '1');
      img.src = fallback;
      return;
    }
    img.hidden = true;
    if (img.nextElementSibling) img.nextElementSibling.hidden = false;
  }, true);
  if (els.emailForm) els.emailForm.addEventListener('submit', handleEmailSubmit);
  if (els.copyButton) els.copyButton.addEventListener('click', handleCopyWantList);
  els.search.addEventListener('input', function () { state.search = this.value || ''; renderGrid(); });
  els.releaseType.addEventListener('change', function () { state.releaseType = this.value || ''; renderGrid(); });
  els.sort.addEventListener('change', function () { state.sort = this.value || 'artist'; renderGrid(); });
  els.wantButton.addEventListener('click', openWantDialog);

  [els.dialog, els.wantDialog].forEach(function (dialog) {
    if (!dialog) return;
    dialog.addEventListener('click', function (event) {
      var rect = dialog.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }
    });
  });
})();
